import axios from "axios";
import request from "./request";
import { REACT_APP_API_URL } from "config";

const USER_KEY = "pu.user";

export const loginUser = (values) =>
  request({
    url: `/auth/phone-login`,
    method: "post",
    data: values,
  });

export const loginUserCode = (values) =>
  request({
    url: `/auth/authenticate-code`,
    method: "post",
    data: values,
  });

export const authToken = (token) =>
  request({ url: `/auth/verify-token`, method: "post", data: token });

export const forgotPassword = (values) =>
  request({
    url: `/auth/forgot-password`,
    method: "post",
    data: values,
  });

export const refreshToken = () =>
  request({
    url: `/auth/refresh`,
    method: "post",
  });

export const storeUser = (user) => {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const getUser = () => {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const logout = async () => {
  localStorage.removeItem(USER_KEY);
  sessionStorage.removeItem(GUEST_TOKEN_KEY);

  try {
    // Use plain axios to avoid the interceptor (which would retry/refresh on 401)
    await axios.get(`${REACT_APP_API_URL}/auth/logout`, {
      withCredentials: true,
    });
  } catch {
    // Ignore errors — we still clear local state
  }
};

export const loggedIn = () => {
  return !!getUser();
};

// Guest token — stored in sessionStorage (cleared on tab close)
const GUEST_TOKEN_KEY = "pu.guestToken";

export const storeGuestToken = (token) => {
  sessionStorage.setItem(GUEST_TOKEN_KEY, token);
};

export const getGuestToken = () => {
  return sessionStorage.getItem(GUEST_TOKEN_KEY);
};

export const clearGuestToken = () => {
  sessionStorage.removeItem(GUEST_TOKEN_KEY);
};
